import Api from "@dwellsocial/dwellsocial-api";

export const loadEventLocations = () => (dispatch) =>
  Api.eventLocation.index().then((event_locations) => {
    dispatch({ type: "LOAD_EVENT_LOCATIONS", event_locations });

    return event_locations;
  });
